module.exports = __webpack_public_path__ + "static/img/Aions_GZ_Mar_7.87ba377.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Aions_GZ_Mar/Aions_GZ_Mar_7.png
// module id = WbaJ
// module chunks = 19